// permissions.js

export const PERMISSIONS = {
  DB: {
    VIEW_CASH: "View cash balances",
    VIEW_LOAN_VOLUME: "View total loan portfolio",
    VIEW_MANUAL_REVIEW: "View items requiring manual review",
    VIEW_ACTIVE_ACCOUNTS: "View active accounts and filter by account type",
    VIEW_ACTIVITY: "View transaction volume and activity",
    VIEW_DEPOSITS: "View deposit breakdown (Mpesa or check-off)",
    VIEW_OUTSTANDING: "View total outstanding balance of loans",
    VIEW_DEFAULTED: "View total amount of loans defaulted",
    VIEW_SHARES_VOLUME: "View shares volume (customers with or without)",
  },

  MB: {
    VIEW_ALL: "View all members",
    ADD_NEW: "Add new member",
    EXPORT_LIST: "Export members list",
    VIEW_DETAILS: "View detailed Member profiles",
    EDIT_INFO: "Edit Member information",
    UNSUSPEND_MEMBER: "Unsuspend a member",
    RESET_PASSWORD: "Reset member password",
    DELETE_MEMBER: "Delete a member",
    CREATE_ACCOUNT: "Create a new member account",
    VIEW_STATEMENTS: "Generate Member Statements",
  },

  TX: {
    VIEW_ALL: "View all transactions",
    VIEW_SUMMARY: "View transaction summary",
    EXPORT: "Export transactions",
    VIEW_TRANSACTION_DETAILS: "View transaction details",
    UPLOAD_BULK: "Upload bulk payments file",
  },

  LN: {
    VIEW_BOOK: "View loan book",
    VIEW_APPLICATIONS: "View loan applications",
    VIEW_VOLUME: "View total loan volume",
    VIEW_FILTERED: "View all loans with filters",
    EXPORT: "Export loans",
    VIEW_DETAILS: "View loan details",
    DISBURSE: "Disburse loans",
    UPDATE_AMOUNT: "Update loan amount",
    UPDATE_TERMS: "Update loan terms",
    APPROVE_REJECT: "Approve or reject loan applications",
    MODIFY_TERMS: "Modify loan terms and conditions",
    VIEW_GUARANTORS_SUMMARY: "View guarantor summary",
    VIEW_ALL_GUARANTORS: "View all guarantors",
    EXPORT_GUARANTORS: "Export guarantors",
    ADD_DEPOSIT: "Add a deposit transaction for loans",
    VIEW_GUARANTORS_DETAILS: "View guarantor details",
  },

  SV: {
    VIEW_ALL: "View all savings and amounts",
    EXPORT: "Export Savings data (on savings page)",
    VIEW_DETAILS: "View savings details",
    ADD_DEPOSIT: "Add deposit transaction",
    VIEW_TXNS: "View savings transactions",
    ADD_TRANS: "Add deposit transaction",
    VIEW_TRANSACTION_DETAILS: "View savings transaction details",
  },

  SH: {
    VIEW_ALL: "View all shareholders and amounts",
    EXPORT: "Export shares data",
    VIEW_DETAILS: "View shares details",
    EXTEND_PERIOD: "Extend purchase period",
    LIST_FOR_SALE: "List shares for sale",
    ADD_DEPOSIT: "Add a deposit transaction for shares",
    VIEW_HISTORY: "View shares transaction history",
    VIEW_TRANSACTION_DETAILS: "View shares transaction details",
  },

  RP: {
    VIEW: "View reports",
    EXPORT: "Export reports",
    VIEW_ANALYTICS: "View Analytics Dashboard",
  },

  UM: {
    VIEW_ALL: "View all users",
    UPDATE_INFO: "Update user information",
    SIGN_OUT: "Sign out user from all sessions",
    SUSPEND: "Suspend user",
    DELETE: "Delete user",
    RESET_PASSWORD: "Reset user password",
    ADD_NEW: "Add new user",
    EXPORT_LIST: "Export user list",
    MANAGE_ROLES: "Create/edit role and set permissions",
    VIEW_AUDIT_TRAIL: "View audit trail",
    EXPORT: "Export audit trail data",
    VIEW_DETAILS: "View audit trail details",
  },

  SC: {
    MANAGE_SETTINGS: "Manage security settings",
    MONITOR_ACL: "Monitor and configure access control lists",
  },
};
